import axios from "axios"
import library from "../../../utils/Library"

export const updateSubscriptionCommunicationVE = async (data) => {
  const TOKEN = sessionStorage.getItem("token")
  const URL =
    library.getBaseAPIUrl("legal_communications") +
    "/updateSubscriptionCommunicationVE"

  return await axios({
    url: URL,
    method: "PATCH",
    headers: {
      Authorization: `Bearer ${TOKEN}`,
    },
    data: {
      communicationSubscriptionVEId: data.communicationSubscriptionVEId,
      serviceStatus: data.serviceStatus,
    },
  })
}
